// 错误页通用模板(共享组件,被 404/403/500/503/offline/agent-error 复用)。
// 对应 .pen 中所有错误页 frame 的相同骨架:大数字 / 标题 / 描述 / 两个按钮。

import type { ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'
import { MobileScreen } from '../../components/mobile-screen'

export type ErrorPageViewProps = {
  frameId: string
  /** 显示的错误代码(如 "404" / "503"),null = 不显示 */
  code: string | null
  title: string
  desc: ReactNode
  /** 调试信息,渲染为小字脚注(reason / trace_id 等) */
  reason?: string | null
  /** 自定义按钮区(默认渲染 backBtn + homeBtn) */
  actions?: ReactNode
  backBtnTestId?: string
  homeBtnTestId?: string
  /** 自定义 icon 区域(默认渲染感叹号圆) */
  icon?: ReactNode
}

export function ErrorPageView({
  frameId,
  code,
  title,
  desc,
  reason,
  actions,
  backBtnTestId,
  homeBtnTestId,
  icon,
}: ErrorPageViewProps) {
  const navigate = useNavigate()
  return (
    <MobileScreen>
      <main
        data-testid={frameId}
        className="flex flex-1 flex-col items-center justify-center px-6 pb-20"
      >
        <span className="flex h-20 w-20 items-center justify-center rounded-full bg-orange-50 text-orange-500">
          {icon ?? (
            <svg
              width="36"
              height="36"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.4"
              strokeLinecap="round"
            >
              <path d="M12 9v4M12 17h.01" />
              <circle cx="12" cy="12" r="10" />
            </svg>
          )}
        </span>
        {code && (
          <p className="mt-4 text-[44px] font-bold tabular-nums leading-none text-gray-300">
            {code}
          </p>
        )}
        <h1 className="mt-3 text-[18px] font-semibold text-[#1A1A1A]">{title}</h1>
        <div className="mt-2 max-w-xs text-center text-[13px] text-[#9CA3AF]">{desc}</div>
        {reason && (
          <p className="mt-2 font-mono text-[10px] text-gray-400">trace: {reason}</p>
        )}

        <div className="mt-8 flex w-full max-w-[300px] flex-col gap-2">
          {actions ?? (
            <>
              <button
                type="button"
                data-testid={homeBtnTestId ?? 'homeBtn'}
                onClick={() => navigate('/')}
                className="h-12 w-full rounded-lg bg-[#19caad] text-[14px] font-semibold text-white active:bg-[#14a18b]"
              >
                返回首页
              </button>
              <button
                type="button"
                data-testid={backBtnTestId ?? 'backBtn'}
                onClick={() => {
                  if (window.history.length > 1) window.history.back()
                  else navigate('/')
                }}
                className="h-12 w-full rounded-lg bg-[#F6F7F8] text-[14px] font-semibold text-[#1A1A1A]"
              >
                返回上一页
              </button>
            </>
          )}
        </div>
      </main>
    </MobileScreen>
  )
}
